export const DATE_FORMAT = 'dd.MM.yyyy';
export const API_DATE_FORMAT = 'YYYYMMDD';
